import { InputAdornment } from "@mui/material";
import lockicon from '../../../../images/lockIcon.png'

export default function NewPotCreate(values) {
    return [
      {
        shape: "div",
        type: "wrapper",
        className: "",
        sx: {
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gridColumnGap: "30px",
        },
        children: [         
          {
            shape: "input",
            type: "text",
            name:"pot_id",
            title: "Pot ID",
            label: "Round ID",
            priceDefaultValue: "100",
            placeholder: "Id",
            currencyDefaultValue: "AMD",
            isDisabled: true,
            inputAdornments:{
              end: values.tokendisable ?  <InputAdornment position="end"> <img src={lockicon} alt = 'lockicon'/></InputAdornment> : '',
            },
            mode: "edit",
            filterBasedOnField: "country",
            optionLabelKey: "name",
            width: '100%',            
          },          
          {
            shape: "input",
            type: "select",
            name:"league",
            title: "League",
            label: "League",
            priceDefaultValue: "100",
            placeholder: "Select League",
            currencyDefaultValue: "AMD",
            isDisabled: false,
            validation: {
                required: true,
                requiredMessage: "League can't be empty",
              },
            mode: "edit",
            options : values?.selectedLeagues,
            customeonchange : values?.getPotCategory,
            filterBasedOnField: "country",
            optionLabelKey: "name",
            width: '100%',         
          },
          {
            shape: "input",
            type: "select",
            name: "category",
            title: "Pot Category",
         //   isDisabled: values.allFieldDisable,
         isDisabled: values.allFieldDisable || !values.onChangeValue,
            label: "Round Category",
            className: "",
            placeholder: `Select Category`,
            width: '100%',   
            options : values.PotSettingList,
            customeonchange : values?.FillPotCategory,
            validation: {
              required: true,
              requiredMessage: "Category can't be empty",
            },
          }
        ],
      },
      {
        shape: "div",
        type: "wrapper",
        className: "",
        sx: {
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gridColumnGap: "30px",
          mt: 3,
        },
        children: [
          {
            shape: "input",
            type: "currencyinput",
            name:"min_pot_value",
            title: "mix pot value",
            label: "Minimum Round value",
            priceDefaultValue: "100",
            placeholder: "Enter the value",
            currencyDefaultValue: "AMD",
            isDisabled: values.allFieldDisable,
            selectDisable: values.mode == 'edit' ? true :   values.allFieldDisable,
            mode: "edit",
            selectDisable: true,
            validation: {
                required: true,
                requiredMessage: "Minimum Round value can't be empty",
              },
            filterBasedOnField: "country",
            optionLabelKey: "name",
            width: '100%',            
          },
          {
            shape: "input",
            type: "currencyinput",
            name:"max_pot_value",
            title: "Maximum pot value",
            label: "Maximum Round value",
            selectDisable: true,
            isDisabled: values.allFieldDisable,
            priceDefaultValue: "100",
            placeholder: "Enter the value",
            currencyDefaultValue: "AMD",
            validation: {
              required: true,
              requiredMessage: "Maximum Round value can't be empty",
            },
            mode: "edit",
            filterBasedOnField: "country",
            optionLabelKey: "name",
            width: '100%',            
          },
          {
            shape: "input",
            type: "text",
            name:"picks_per_player",
            title: "no_of_player *",
            label: "No. of picks per player",
            priceDefaultValue: "100",
            placeholder: "Enter the value",
            currencyDefaultValue: "AMD",
            isDisabled: values.allFieldDisable,
            selectDisable: true,
            validation: {
                required: true,
                requiredMessage: "No. of picks per player can't be empty",
              },
            mode: "edit",
            filterBasedOnField: "country",
            optionLabelKey: "name",
            width: '100%',   
          }
        ],
      },
      {
        shape: "div",
        type: "wrapper",
        className: "",
        sx: {
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gridColumnGap: "30px",
          mt: 3,
        },
        children: [         
          {
            shape: "input",
            type: "number",
            name: "min_picks_for_splitting",
            title: "Minimum players to split the round",
            label: "Minimum players to split the round",
            className: "",
            placeholder: `Enter number of players`,
            isDisabled: values.allFieldDisable,
            width: '100%',            
            validation: {
              required: true,
              requiredMessage: "Minimum players to split the pot * can't be empty",
            },
          },          
          {
            shape: "input",
            type: "number",
            name: "adminfee",
            title: "Admin fee ",
            label: "Admin fee ",
            className: "",
            placeholder: `Enter the value`,
            isDisabled: values.allFieldDisable,
            width: '100%',            
            validation: {
              required: true,
              requiredMessage: "Admin fee can't be empty",
            },
            inputAdornments:{
              end: <InputAdornment position="end"> % </InputAdornment>,
            }
          },
          {
            shape: "input",
            type: "number",
            name: "prediction_deadline",
            title: "Deadline for picks",
            label: "Deadline for picks",
            className: "",
            placeholder: `Enter number of hours`,
            width: '100%',            
            validation: {
              required: true,
              requiredMessage: "Deadline for prediction * can't be empty",
            },
            isDisabled: values.allFieldDisable,
          }
        ],
      },
      {
        shape: "div",
        type: "wrapper",
        className: "",
        sx: {
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gridColumnGap: "30px",
          mt: 1,
        },
        children: [         
            {
                shape: "input",
                type: "number",
                name: "tokens_per_pick",
                title: "No. of tokens per pick",
                label: "No. of tokens per pick",
                className: "",
                width: '100%',     
                validation: {},
                isDisabled: true,         
          },  
          {
            shape: "input",
            type: "number",
            name: "dead_line_voting",
            // handleChange: "",           
            title: "dead_line_voting",
            label: "No. of Deadline Voting",
            className: "",
            placeholder: `Enter the value`,
            width: '100%',     
            isDisabled: values.allFieldDisable,  
            validation: {
              required: true,
              requiredMessage: "Deadline Voting can't be empty",
            },     
          },
          // NEW MATCH WEEK DROPDOWN
          // {
          //   shape: "input",
          //   type: "select",
          //   name: "match_week",
          //   title: "Start Match Week",
          //   label: "Start Match Week",
          //   className: "",
          //   placeholder: "Select Start Match Week",
          //   width: '100%',
          //   isDisabled: values.allFieldDisable || !values.onChangeValue,
          //   options: values?.matchWeekList || [],
          //   validation: {
          //     required: values?.matchWeekList?.length > 0 && values?.matchWeekList?.[0]?.id !== null,
          //     requiredMessage: "Start Match Week can't be empty",
          //   },
          //   optionLabelKey: "name",
          //   optionValueKey: "id",
          // }
          {
  shape: "input",
  type: "select",
  name: "match_week",
  title: "Start Match Week",
  label: "Start Match Week",
  className: "",
  placeholder: "Select Start Match Week",
  width: '100%',
  isDisabled: values.allFieldDisable || !values.onChangeValue,
  options: values?.matchWeekList || [],
  // Add default value - first item from matchWeekList (current match week)
  defaultValue: values?.matchWeekList?.[0]?.id || null,
  validation: {
    required: values?.matchWeekList?.length > 0 && values?.matchWeekList?.[0]?.id !== null,
    requiredMessage: "Start Match Week can't be empty",
  },
  optionLabelKey: "name",
  optionValueKey: "id",
}         
        ],
      },
      {
        shape: "div",
        type: "wrapper",
        className: "",
        sx: { display: "flex", justifyContents: "flex-start", mt: 3 },
        children: [
          {
            shape: "button",
            type: "action",
            title: values.mode === "view" ? "Edit" : "Create",
            submitButton : values.isupdate,
            name: "Create",
            sx : {mr:2,ml:0,
              backgroundColor : '#3C50E0',
              px:4,
            borderRadius: '4px',
            border : '1px solid #3C50E0',
            '&:hover': {
              backgroundColor: '#3C50E0',
              border : '1px solid #3C50E0'
            },},
            validation: {
              hiddenRules: [
                {
                  mode: "view",
                },
              ],
            },
          },
          {
            shape: "button",
            type: "cancel",
            title: "Cancel",
            name: "cancel",
            sx: {
              mr: 2,
              color: '#000',
              px: 4,
              borderRadius: '4px',
              backgroundColor : '#fff',
              border : '1px solid #E2E8F0',
              '&:hover': {
                backgroundColor: '#fff',
                border : '1px solid #E2E8F0'
              },
            },
          },
        ],
      },
    ];
  }